<script setup lang="ts">
import { useAuthStore } from '../stores/auth';
import kilnLogo from '../assets/kiln-logo.png';

const authStore = useAuthStore();

function handleLogin() {
  authStore.login();
}
</script>

<template>
  <div class="login-container">
    <div class="login-card">
      <img :src="kilnLogo" alt="Kiln" class="login-logo" />
      <p class="login-subtitle">CI/CD Build System</p>
      <div v-if="authStore.loading" class="loading">
        Initializing...
      </div>
      <div v-else>
        <button @click="handleLogin" class="login-button">
          Sign In
        </button>
      </div>
      <div v-if="authStore.error" class="error">
        {{ authStore.error }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--color-loading-gradient-start) 0%, var(--color-loading-gradient-end) 100%);
}

.login-card {
  background: var(--color-card-bg);
  padding: 48px;
  border-radius: 8px;
  box-shadow: 0 4px 20px var(--color-card-shadow);
  text-align: center;
  min-width: 320px;
}

.login-logo {
  height: 256px;
  margin-bottom: 8px;
}

.login-subtitle {
  margin: 0 0 32px 0;
  color: var(--color-text-secondary);
}

.login-button {
  background: var(--color-header-bg);
  color: var(--color-header-text);
  border: none;
  padding: 12px 32px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}

.login-button:hover {
  opacity: 0.9;
}

.loading {
  color: var(--color-text-secondary);
  padding: 12px;
}

.error {
  margin-top: 16px;
  color: var(--color-error-text);
  font-size: 0.875rem;
}
</style>
